import React from 'react';
import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { makeCall } from 'utils/utils';
import { tableContainerStyles as useStyles } from 'styles/common';
import MaterialTable, { MTableToolbar } from '@material-table/core';
import WithMotion from 'components/withMotion';
import { ModalType, Network, Merchant, Category, Country, Currency, Account, Media } from 'types/global';
import { Data, Record, FilterFormData } from './types';
import { columns } from './initialData';
import FiltersForm from './FiltersForm';
import Create from './Create';
import Update from './Update';
import EnhancedSnackbar from 'components/EnhancedSnackbar';

function Programs() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<Data[]>([]);
  const [modalType, setModalType] = useState<ModalType>(null);
  const [record, setRecord] = useState<Record>(null);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [filters, setFilters] = useState<any>({});
  const [networks, setNetworks] = useState<Network[]>([]);
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [medias, setMedias] = useState<Media[]>([]);
  const [accounts, setAccounts] = useState<Account[]>([]);

  useEffect(() => {
    makeCall('networks', 'GET').then((res) => setNetworks(res?.data.data));
    makeCall('merchants', 'GET').then((res) => setMerchants(res?.data.data));
    makeCall('programs/categories', 'GET').then((res) => setCategories(res?.data.data));
    makeCall('currencies', 'GET').then((res) => setCurrencies(res?.data.data));
    makeCall('countries', 'GET').then((res) => setCountries(res?.data.data));
    makeCall('medias', 'GET').then((res) => setMedias(res?.data.data));
    makeCall('accounts', 'GET').then((res) => setAccounts(res?.data.data));
  }, []);

  const fetchData = async (payload: any) => {
    const response = await makeCall('programs', 'GET', payload);
    setData(response?.data.data);
    setIsLoading(false);
  };

  const getRecord = async (clickedRow: Data) => {
    const response = await makeCall(`programs/${clickedRow.programUuid}`, 'GET');
    setRecord(response?.data.data);
    setModalType('update');
  };

  const handleFiltersSubmit = (filtersData: FilterFormData) => {
    setIsLoading(true);
    fetchData(filtersData);
    setFilters(filtersData);
  };

  const refresh = (key: string) => {
    const message = `Program ${key} successfully!`;
    setToastMessage(message);
    setToastOpen(true);
    setIsLoading(true);
    fetchData(filters);
  };

  return (
    <>
      <Create
        open={modalType === 'create'}
        handleClose={() => setModalType(null)}
        refresh={() => refresh('created')}
        currencies={currencies}
        countries={countries}
        networks={networks}
        merchants={merchants}
        categories={categories}
      />
      <Update
        open={modalType === 'update'}
        handleClose={() => setModalType(null)}
        refresh={() => refresh('updated')}
        record={record}
        categories={categories}
        currencies={currencies}
        countries={countries}
        medias={medias}
        accounts={accounts}
      />
      <FiltersForm
        networks={networks}
        merchants={merchants}
        categories={categories}
        handleFiltersSubmit={handleFiltersSubmit}
      />
      <EnhancedSnackbar open={toastOpen} message={toastMessage} onClose={() => setToastOpen(false)} />
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <MaterialTable
            title="Programs"
            components={{
              Toolbar: (props) => (
                <div className={classes.toolbarWrapper}>
                  <MTableToolbar {...props} />
                </div>
              ),
            }}
            options={{
              search: true,
              pageSize: 10,
              actionsColumnIndex: 9,
              actionsCellStyle: { color: '#666' },
            }}
            actions={[
              {
                icon: 'add',
                tooltip: 'Create program',
                isFreeAction: true,
                onClick: () => setModalType('create'),
              },
              {
                icon: 'edit',
                tooltip: 'Update program',
                isFreeAction: false,
                onClick: (event, rowData: any) => getRecord(rowData),
              },
            ]}
            isLoading={isLoading}
            columns={columns}
            data={data}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default WithMotion(Programs);
